export const SET_AOIS = "SET_AOIS";



// WEBPACK FOOTER //
// ./src/constants/aoi.js